export const skillList = [
    {
        skillName: 'HTML',
        id:1,
        skillUrl: 'https://cdn-icons-png.flaticon.com/512/732/732212.png',
    },
    {
        skillName: 'CSS',
        id:2,
        skillUrl: 'https://cdn-icons-png.flaticon.com/512/732/732190.png',
    },
    {
        skillName: 'Bootstrap',
        id:3,
        skillUrl: 'https://camo.githubusercontent.com/3fc76f75ed6afe536a88dc788ca13147253daf41b9a2e0241d8003fce609c7d4/68747470733a2f2f63646e2e69636f6e73636f75742e636f6d2f69636f6e2f667265652f706e672d3235362f626f6f7473747261702d372d313137353235342e706e67',
    },
    {
        skillName: 'JavaScript',
        id:4,
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/js.png',
    },
    
    {
        skillName: 'React',
        id:5,
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/react.png',
    },
    {
        skillName: 'Redux',
        id:6,
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/redux.png',
    },
    {
        skillName: 'Core Java',
        id:7,
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/java.png',
    },
    {
        skillName: 'MySql',
        id:8,
        skillUrl: 'https://styles.redditmedia.com/t5_2qm6k/styles/communityIcon_dhjr6guc03x51.png?width=256&s=3e825b7205c7f497d4695028e358d26ee359f84b',
    },
    {
        skillName: 'Firebase',
        id:9,
        skillUrl: 'https://cdn4.iconfinder.com/data/icons/google-i-o-2016/512/google_firebase-2-512.png',
    },
    {
        skillName: 'Python',
        id:10,
        skillUrl: 'https://cdn.icon-icons.com/icons2/1508/PNG/512/python_104451.png',
    },
    
];
